import * as React from "react";
const SvgOpenInNew = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 1.871V22.13H22.13V1.87H12ZM3.38 3.38H20.62V20.62H3.38V12Zm7.758 4.406v1.508h2.509l-2.964 2.965-2.963 2.963.529.531.531.53 2.965-2.964 2.963-2.964v2.509h1.508V7.785h-2.54z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgOpenInNew;
